import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'fronton-react';
import { cx } from 'linaria';
import { itemContent, itemDescription, itemButton } from './styles';
import { Direction } from '../types';

type Props = {
  title: string;
  description: string;
  dir: Direction;
  hideLearnMore?: boolean;
};

export const ProjectContent: FC<Props> = ({ title, description, dir, hideLearnMore = false }) => {
  const { t } = useTranslation();

  return (
    <div className={cx(itemContent, dir)}>
      <Typography variant="h3" color="text-invert">
        {title}
      </Typography>
      <Typography variant="s" size="body_long" color="text-invert" className={itemDescription}>
        {description}
      </Typography>
      {!hideLearnMore && (
        <div data-qa="project-button" className={itemButton}>
          <Typography color="text-invert" variant="s" size="body_accent">
            {t('learnMore')}
          </Typography>
        </div>
      )}
    </div>
  );
};
